export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-brush/src/constant.js
// module id = XEQx
// module chunks = 0